import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_8: FaireProductEntity = {
  token: "beverage-8",
  type: "product",
  name: "Chai Tea Blend",
  brandName: "Tea Leaf Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8214621cb3ab970168b2f23ffad9c39b1dec1d42c8b2bb40239c1e7d7d77a7ae.webp",
  priceDollars: 16,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
